import React from 'react';
import styled from 'styled-components';

import CardHeader from 'components/CardHeader';
import Card from 'components/Card';
import Spinner from 'components/Spinner';
import IndicatorNoteBox from '../IndicatorNote';

const Center = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Container = styled.div`
  position: relative;
  display: grid;
  border-radius: 4px;
  background-color: ${(props) => props.theme.colors['white-two']};

  .recapIndicatorsContainer {
    display: block;
    width: 100%;
    height: 100%;

    span {
      font-weight: bold;
    }
  }

  .card {
    height: calc(100% - 60px);
  }

  .infos {
    opacity: 0.5;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    font-weight: normal;
    font-style: italic;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors['dark']};
  }

  b {
    font-weight: 600;
  }
  ${(props) => props.styles}
`;

const WxrKpi = (props) => {
  return (
    <Container styles={props.styles}>
      <Card className="card">
        <CardHeader
          title={props.title}
          fontSize="20px"
          iconRight="right"
          iconColor="#e25d34"
        />
        <Center>
          <div className="recapIndicatorsContainer">
            {props.indicators.map((indicator, index) => (
              <IndicatorNoteBox key={`indicator-${index}`} {...indicator} />
            ))}
          </div>
          <div className="infos">{props.infos}</div>
        </Center>
      </Card>
      <Spinner loading={props.loading} little />
    </Container>
  );
};

export default WxrKpi;
